import { useRef, useState, useEffect, RefObject } from 'react';

type UseClickOutsideReturn = [RefObject<HTMLDivElement>, boolean, (event: MouseEvent) => void];

const useClickOutside = (defaultState: boolean): UseClickOutsideReturn => {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState<boolean>(defaultState);

  const handleClickOutside = (event: MouseEvent) => {
    if (!ref.current || !ref.current.contains(event.target as Node)) setActive(false);
    else setActive(true);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
  return [ref, active, handleClickOutside];
};

export default useClickOutside;
